import Login from './views/login';
import Profile from './views/profile';
import Unautorized from './views/unautorized';
import Oauth from './views/oauth';
import SsoCallback from './views/ssoCallback';

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {layout: "layoutUser", pageOrder: 0}
  },
  {
    path: '/unautorized',
    name: 'Unautorized',
    component: Unautorized,
    meta: {layout: "layoutUser", pageOrder: 0}
  },
  {
    path: '/oauth',
    name: 'Oauth',
    component: Oauth
  },
  {
    path: '/sso/callback',
    name: 'SsoCallback',
    component: SsoCallback
  },
];
